import {ChangeDetectionStrategy, Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";

@Component({
    selector: "section-warehouse-order-exception-list",
    template: `
        <section-warehouse-order-list [state]="state" [status]="'exception'"
                                      header="Orders with exceptions"></section-warehouse-order-list>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarehouseOrderExceptionListComponent implements Base.IComponent {


    public readonly state: Base.IState;

    public constructor() {
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "warehouse-orders-exception",
            actions: {
                "browse": ["browse_warehouse_orders"]
            }
        };
    }

}
